module.exports = __webpack_public_path__ + "img/border_Form.6f9c19aa.svg";